import { render, staticRenderFns } from "./BusinessReferences.vue?vue&type=template&id=3ec9c78b&"
import script from "./BusinessReferences.vue?vue&type=script&lang=js&"
export * from "./BusinessReferences.vue?vue&type=script&lang=js&"
import style0 from "./BusinessReferences.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports